import React, { useState } from "react";
import SearchDropDown from "../common/SearchDropDown";
import { USER_TYPE } from "../../constant";

export default function CandidateSearch({val, setVal}) {
  const [value, setValue] = useState([]);

  return (
    <SearchDropDown
      mode="multiple"
      value={value}
      val={val}
      setVal={setVal}
      placeholder="Search"
      type={USER_TYPE.CANDIDATE}
      onChange={(newValue) => {
        setValue(newValue);
      }}
      style={{
        width: "100%",
      }}
    />
  );
}
